import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=4da3540c&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=4da3540c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports